const CHUNK_ERROR_PATTERN =
  /ChunkLoadError|Loading chunk|Failed to load chunk|dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;

function isChunkError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  return error.name === 'ChunkLoadError' || CHUNK_ERROR_PATTERN.test(error.message);
}

// React error-boundary entry point for a ChunkLoadError (a lazy import whose chunk the
// current build dropped). Delegates to the inline <head> script's healer
// (`window.__cmHealChunk`, see chunk-recovery-script.ts) which owns the guarded
// reload-with-fresh-marker so the logic lives in one place. Returns true when a reload
// was initiated (caller then renders a "recovering" state instead of the error UI).
export function recoverFromChunkError(error: unknown): boolean {
  if (typeof window === 'undefined' || !isChunkError(error)) {
    return false;
  }
  // biome-ignore lint/style/useNamingConvention: global hook name set by the inline head script
  const heal = (window as unknown as { __cmHealChunk?: () => boolean }).__cmHealChunk;
  return typeof heal === 'function' ? heal() : false;
}
